import {
  HandleValidDate,
  FormatDate,
  FormatDateDDMMMYYYY,
} from "helpers/method_helper"
const HouseholdMonitoringColumnsForExport = [
  {
    Header: "Month",
    accessor: "TrainingMonth",
  },
  {
    Header: "Postcode Area",
    accessor: "Postcode",
  },
  {
    Header: "Households with Children",
    accessor: "ChildrenCount",
  },
  {
    Header: "Households with Pensioners",
    accessor: "PensionerCount",
  },
  {
    Header: "Households with Disabled Person",
    accessor: "DisabledCount",
  },
  {
    Header: "Other Households",
    accessor: "OtherCount",
  },
  {
    Header: "Training Date",
    accessor: row =>
      row.TrainingDate ? FormatDateDDMMMYYYY(row.TrainingDate) : "",
  },
  {
    Header: "Venue Name",
    accessor: "Venue",
  },
  {
    Header: "Training Type",
    accessor: "TrainingType",
  },
  {
    Header: "Training Subjects",
    accessor: "Subjects",
  },
  {
    Header: "Delivery Postcode",
    accessor: "Delivery",
  },
  {
    Header: "Created By",
    accessor: "CreatedByName",
  },
  {
    Header: "Created Date",
    accessor: row =>
      row.CreatedDate ? FormatDateDDMMMYYYY(row.CreatedDate) : "",
  },
]
export { HouseholdMonitoringColumnsForExport }
